// extracted by mini-css-extract-plugin
module.exports = {"root":"Collezione_root__2mUSk","h1":"Collezione_h1__d0yQa","iframeWrap":"Collezione_iframeWrap__1prjd","iframe":"Collezione_iframe__HETho"};